import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withAuth } from '@okta/okta-react';
import { setPageTitleAction } from '../../actions/actions';
import MasterDataUtilities from '../../data/MasterDataUtilities';
import { DrcTabs } from 'driscolls-react-components';
import CountryRestrictions from '../../components/Restrictions/countryRestrictions';
import PurRestrictions from '../../components/Restrictions/purRestrictions';
import AppsIcon from '@material-ui/icons/Apps';
import PublicIcon from '@material-ui/icons/Public';

const pageTitle = 'Restrictions';

let styles = (theme) => ({
    subTabItems: {
        border: '1px solid black',
        backgroundColor: ''
    },
    panel: {
        border: `none`,
        marginTop: `2rem`,
        borderRadius: 2,
        boxShadow: `0 2px 4px 0 #C3C3C3`
    },
    tabItem: {
        color: 'gray !important',
        margin: '4px 0 -5px 0',
        padding: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        paddingBottom: theme.spacing(0.5),
        minWidth: theme.spacing(15)
    },
    tabItemButton: {
        borderRadius: 4,
        marginRight: 8,
        border: '1px solid #C3C3C3'
    },
    activeTabItem: {
        color: `#FFFFFF !important`,
        borderBottom: `2px solid #FFFFFF`,
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(0.5)
    },
    tabIcon: {
        transform: 'translateY(4px)',
        marginRight: 4
    }
});

const allGroups = (window.config.OKTA_ADMIN_GROUPS || []).concat(window.config.OKTA_REGULAR_GROUPS || [], window.config.OKTA_READ_ONLY_GROUPS || []);

const ChemicalActivity = (props) => {
    const { classes, isMasterDataInitialized, setPageTitle } = props;

    const tabs = [
        {
            tabName: (
                <div>
                    <span>
                        <AppsIcon className={`${classes.tabIcon}`} />
                    </span>
                    <span>PUR</span>
                </div>
            ),
            component: PurRestrictions,
            route: '/PUR',
            tabIndex: 0,
            isDefault: true,
            groupsAllowed: allGroups
        },
        {
            tabName: (
                <div>
                    <span>
                        <PublicIcon className={`${classes.tabIcon}`} />
                    </span>
                    <span>Country</span>
                </div>
            ),
            component: CountryRestrictions,
            route: '/Country',
            tabIndex: 1,
            groupsAllowed: allGroups
        }
    ];

    useEffect(() => {
        setPageTitle(pageTitle);
        if (!MasterDataUtilities.Check(isMasterDataInitialized)) {
            MasterDataUtilities.Redirect();
        }
    }, [setPageTitle, isMasterDataInitialized]);

    return (
        <DrcTabs
            classes={{
                root: classes.tabItem,
                tabItem: `${classes.tabItem} ${classes.tabItemButton}`,
                activeTabItem: classes.activeTabItem
            }}
            menuItems={tabs}
            registerRoutes
        ></DrcTabs>
    );
};

const mapStateToProps = (state) => {
    return {
        isMasterDataInitialized: state.masterReducer.isInitialized,
        ranch: state.ranchOverview.ranch,
        noApplication: state.ranchOverview.noApplication
    };
};

const mapDispatchToProps = (dispatch) => ({
    setPageTitle: (title) => dispatch(setPageTitleAction(title))
});

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChemicalActivity)));
